import React, { Component } from 'react'
import { connect } from 'react-redux'

import Fade from 'material-ui/transitions/Fade'
import { CircularProgress } from 'material-ui/Progress'
import Snackbar from 'material-ui/Snackbar'
class LoadingContainer extends Component {
    render() {
        return(
            <Snackbar
                    open={this.props.loading.isLoading}
                    transition={Fade}
                    action={<CircularProgress size={25}/>}
                    SnackbarContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{this.props.loading.message} </span>}/>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.loading
    }
}

export default connect(mapStateToProps,null)(LoadingContainer)


// WEBPACK FOOTER //
// ./src/main/LoadingContainer.js